<template>
  <fh-container>
    <fh-crud-establecimientos
      :formTitle="title"
      v-on:terminated="checkEstablecimientoSet"
    >
    </fh-crud-establecimientos>
  </fh-container>
</template>

<script>
import FhCrudEstablecimientos from '@/components/app/FhCrudEstablecimientos.vue'
import FhContainer from '@/components/FhContainer'
import {mapActions, mapGetters, mapState} from 'vuex'


export default {
  name:'CrearEstablecimiento',
  components: {FhContainer, FhCrudEstablecimientos},
  data(){
    return{
      title: 'Usted no tiene establecimientos registrados. Crea uno para seguir.'
    }
  },
  computed: {
    ...mapState('session', [
      'isRestored',
    ]),
    ...mapState('agricultor', [
      'agricultor',
    ]),
    ...mapGetters('establecimientos',[
      'isEstablecimientoSet',
      'hasCategoriaAgricultura',
      'hasCategoriaGanaderia',
    ]),
    ...mapState('establecimientos', [
      'establecimiento',
      'establecimientosList',
    ]),
  },
  methods:{
    ...mapActions('establecimientos',[
      'fetchEstablecimientosList',
      'clearEstablecimiento',
      'clearEstablecimientoList',
      'setEstablecimiento',
    ]),
    async checkEstablecimientoSet(){
      await this.clearEstablecimientoList()
      await this.fetchEstablecimientosList(this.agricultor.idAgricultor)

      if(this.establecimientosList.length !== 0){
        await this.setEstablecimiento(this.establecimientosList[0])
      }
      if(this.hasCategoriaAgricultura){
        this.$router.push({name:'AgroHome'}).catch(() => {})
      }else{
        this.$router.push({name:'GanaderiaHome'}).catch(() => {})
      }
    }
  },
  async created(){
    while (!this.isRestored) {
      await this.$sleep(10)
    }
    if(this.isEstablecimientoSet){
      if(this.hasCategoriaAgricultura){
        this.$router.push({name:'AgroHome'}).catch(() => {})
      }else{
        this.$router.push({name:'GanaderiaHome'}).catch(() => {})
      }
    }
  }
}
</script>